import React from "react";
import Typography from "@material-ui/core/Typography";
import {exportacionesResources, panelSodimacResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import useToken from "../useToken";
import SnackbarAlert from "../components/SnackbarAlert";
import DialogExportar from "../components/DialogExportar";
import {Card, CardActions, CardHeader} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";

class ExportacionesPanel extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            exportaciones:[],
            cliente:null,
            open: false,
            message: '',
            severity: '',
            openSnack: false,
            mes : "",
            solicitaMes: false,
            tipo: ""
        }
    }

    handleClose = () =>{
        this.setState({open:false})
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, openSnack: false})
        if (severity){
            this.setState({
                open: false,
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }

    obtenerExportaciones = () =>{
        exportacionesResources.getExportaciones().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({exportaciones:result})
        }).catch(error=> {
            console.log(error)
        });

    }

    componentDidMount() {
        this.obtenerExportaciones()
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app})
    }

    enviarDatosReportes =(nombre)=>{
        let params = ""
        this.setState({open: true, reporte: nombre, params: params,openSnack:false})
    }

    exportarExcel = (tipo) => {
        this.setState({ openSnack:false,solicitaMes: false});
        let ruta = null;
       
        if (!this.state.mes) return;
        const [anio, mes] = this.state.mes.split("-")

        let inicio = `${anio}-${mes}-01`

        const ultimoDia = String(new Date(anio, mes, 0).getDate()).padStart(2,"0")

        let termino = `${anio}-${mes}-${ultimoDia}`

        if (tipo === 'visual') {
            ruta = () => panelSodimacResources.generarExcelConsoAudVisual(inicio, termino);
        } else if (tipo === 'altillo') {
            ruta = () => panelSodimacResources.generarExcelConsoAudAltillo(inicio, termino);
        } else if (tipo === 'detalle_altillo') {
            ruta = () => panelSodimacResources.generarExcelDetalleAudAltillo(inicio, termino);
        } else {
            ruta = () => panelSodimacResources.generarExcelConsoValidaciones(inicio, termino);
        }

        ruta().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if (result.message) {
                this.setState({
                    openSnack:true,
                    message: result.message,
                    severity: result.severity,
                    mes: ""
                });
            } else {
                throw new Error('Something went wrong ...');
            }
        }).catch(error => {
            console.error(error);
            this.setState({
                openSnack:true,
                message:"Ha ocurrido un error inesperado",
                severity:"error",
                mes: ""
            });
        });

        setTimeout(() => {
            this.setState({open:false});
        }, 6000);
    };

    generarMeses = () => {
        const meses = []

        const inicio = new Date(2025, 9, 1) // octubre 2025
        const fin = new Date() // mes actual

        const fecha = new Date(inicio)

        while (fecha <= fin) {

            const label = fecha.toLocaleString("es-ES", {
                month: "long",
                year: "numeric"
            }).toUpperCase()

            const value = `${fecha.getFullYear()}-${String(fecha.getMonth()+1).padStart(2,"0")}`

            meses.push({
                label,
                value
            })

            fecha.setMonth(fecha.getMonth() + 1)
        }

        return meses
    }



    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Exportaciones
                </Typography>
                    <Grid container direction="row" alignItems="center" spacing={2}>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9", display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL AUD VISUAL"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("consolidado_auditoria_visual")}>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card></Grid>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL AUD ALTILLOS"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("consolidado_auditoria_altillo")}>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL VALIDACIONES"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() => this.enviarDatosReportes("consolidado_validaciones")}>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL VALIDACIONES (XLSX)"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() =>this.setState({solicitaMes: true, tipo: 'validaciones'}) }>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9", display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL AUD VISUAL (XLSX)"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() =>this.setState({solicitaMes: true, tipo: 'visual'}) }>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card></Grid>
                        <Grid item>
                            <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                <CardHeader title="CONSOLIDADO MENSUAL AUD ALTILLOS (XLSX)"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() =>this.setState({solicitaMes: true, tipo: 'altillo'})}>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                         <Grid item>
                            <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                <CardHeader title="DETALLE MENSUAL AUD ALTILLOS (XLSX)"/>
                                <CardActions>
                                    <Button startIcon={ <SvgIcon>
                                        <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                    </SvgIcon>} variant="contained" name="avance" color="primary" onClick={() =>this.setState({solicitaMes: true, tipo: 'detalle_altillo'})}>
                                        EXPORTAR</Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose}/> : null}
                {this.state.solicitaMes ?
                        <Dialog
                            open={true}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description">
                            <DialogTitle id="alert-dialog-title">Opciones disponibles</DialogTitle>
                            <DialogContent style={{display:'inline-grid'}}>
                                <Typography variant={'h6'}>
                                    Mes:
                                </Typography>
                                <Autocomplete
                                    size="small"
                                    options={this.generarMeses()}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.label}
                                    onChange={(event, newValue) => {
                                        if(newValue === null){
                                            this.setState({mes:''})
                                        }
                                        else{
                                            this.setState({mes:newValue.value})
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            label="Mes"
                                            placeholder="Seleccione mes"
                                        />
                                    )}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" color="secondary" onClick={() => this.setState({solicitaMes: false, mes: ''})}>
                                    Cancelar
                                </Button>
                                <Button disabled={this.state.mes === ''} onClick={() => this.exportarExcel(this.state.tipo)} variant="contained" color="primary" >
                                    Exportar
                                </Button>  
                            </DialogActions>
                        </Dialog>
                        : null}
            </div>
        )
    }
}
export default ExportacionesPanel;